import { FC } from 'react';

export const ToolbarBrand: FC = () => {
  return (
    <a href="https://guiadepatas.com.br/" className="flex items-center">
      <img src={"https://storage.codeinformatica.com.br/guiadepatas.webp"} 
        className="mr-3 md:ml-8 md:h-20 h-14" alt="Logo" />
    </a>
  );
};
